"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const ValueField_1 = __importDefault(require("../ValueField"));
const style_1 = require("./style");
const log = (0, core_1.getLogger)('containers/InvestmentHoldingHeader/index.js');
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
log.log('loaded');
const HeaderBoxTitle = styled_components_1.default.div `
  position: relative;
  padding-bottom: 5px;
  margin: 0;
  width: 100%;
  background-color: white;
  font-size: 13px;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const InvestmentHoldingHeader = (props) => {
    const accounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state));
    const { classes } = useStyles();
    // log.debug('InvestmentHoldingHeader props:', props);
    const { accountNode, sortedHoldings } = props;
    let totalValue = 0;
    let todaysChange = 0;
    let todaysChangePercent = 0;
    let cashBalance = 0;
    if (accountNode && accountNode.allAccountIds && accountNode.allAccountIds.size > 0 && (accounts === null || accounts === void 0 ? void 0 : accounts.size) > 0) {
        accountNode.allAccountIds.map((id) => {
            var _a, _b;
            cashBalance += (_b = (_a = accounts.get(id)) === null || _a === void 0 ? void 0 : _a.cashBalance) !== null && _b !== void 0 ? _b : 0;
            return null;
        });
    }
    if (sortedHoldings.size > 0) {
        sortedHoldings.valueSeq().forEach((holding) => {
            if (holding.amount && holding.amount !== 'N/A') {
                totalValue += (Number(holding.amount));
            }
            if (holding.quoteChange && !Number.isNaN(holding.quoteChange) && holding.numberOfShares) {
                if (todaysChange !== 'N/A')
                    todaysChange += (holding.quoteChange * holding.numberOfShares);
            }
        });
        const currentTotal = totalValue + cashBalance;
        const yesterdayTotal = currentTotal - todaysChange;
        if (Math.abs(yesterdayTotal) > 0.01) {
            if (yesterdayTotal > 0) {
                todaysChangePercent = (((currentTotal / yesterdayTotal) - 1) * 100);
            }
            else {
                todaysChangePercent = ((1 - (currentTotal / yesterdayTotal)) * 100);
            }
        }
        else {
            todaysChangePercent = 'N/A';
        }
    }
    else {
        todaysChange = 'N/A';
        todaysChangePercent = 'N/A';
    }
    totalValue += cashBalance;
    return (<div className={classes.gridWrap}>
      <Grid_1.default container direction="row" justifyContent="space-between" spacing={3} className={classes.gridRoot}>
        <Grid_1.default item xs={4} sm={4} md={4}>
          <RendersCount_1.default id={'investmentHoldingHeader'}/>
          <Paper_1.default classes={{ root: classes.headerBox, rounded: classes.headerBoxRounded }}>
            <HeaderBoxTitle>Total Value</HeaderBoxTitle>
            <ValueField_1.default inputValue={totalValue}/>
          </Paper_1.default>
        </Grid_1.default>
        <Grid_1.default item xs={4} sm={4} md={4}>
          <Paper_1.default classes={{ root: classes.headerBox, rounded: classes.headerBoxRounded }}>
            <HeaderBoxTitle>Cash Balance</HeaderBoxTitle>
            <ValueField_1.default inputValue={cashBalance}/>
          </Paper_1.default>
        </Grid_1.default>
        <Grid_1.default item xs={4} sm={4} md={4}>
          <Paper_1.default classes={{ root: classes.headerBox, rounded: classes.headerBoxRounded }}>
            <HeaderBoxTitle>{'Today\'s Change'}</HeaderBoxTitle>
            <ValueField_1.default inputValue={todaysChange} color="sign"/>
            <ValueField_1.default inputValue={todaysChangePercent} color="sign" type="percentage"/>
          </Paper_1.default>
        </Grid_1.default>
      </Grid_1.default>
    </div>);
};
exports.default = InvestmentHoldingHeader;
